module.exports = __webpack_public_path__ + "img/Hunter-dwarf-m-60.14e75a0b.gif";